import(/* webpackMode: "eager" */ "/codebuild/output/src339562424/src/prism-app/prismx-landing/app/page.tsx");
